/* eslint-disable no-param-reassign */
/**
 * @file 计时器
 * @description 利用setTimeout 模拟 setInterval
 */
import { MutableRefObject } from 'react';

const useInterval = () => {
  const mySetInterval = (timeRef: MutableRefObject<any>, delay: number, cb: () => void) => {
    timeRef.current = setTimeout(function run() {
      cb();
      clearTimeout(timeRef.current);
      timeRef.current = setTimeout(run, delay);
    }, delay);
  };

  const clearMyInterval = (timeRef: MutableRefObject<any>) => {
    if (!timeRef.current) return;
    clearTimeout(timeRef.current);
    timeRef.current = null;
  };

  return {
    mySetInterval,
    clearMyInterval
  };
};

export default useInterval;
